module.exports = __webpack_public_path__ + "media/bootstrap-icons/code-square-505e3447.svg";